<template>
    <div id="bmap" class="bmap" />
</template>
<script>
export default {
    name: 'BdMap',
    props: {
        data: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            longitude: 116.299195, // 经度
            latitude: 39.952333, // 纬度
            address: ''
        }
    },
    watch: {
        data(newV, oldV) {
            console.log(newV, oldV)
            this.address = newV.area
            this.mapInit()
        }
    },
    mounted() {
    },
    methods: {
        mapInit() {
            this.address = this.data.area
            const map = new BMap.Map('bmap')
            map.centerAndZoom(new BMap.Point(this.longitude, this.latitude), 15)
            map.enableScrollWheelZoom(true)

            const point = new BMap.Point(this.longitude, this.latitude)
            const marker = new BMap.Marker(point)
            map.addOverlay(marker)

            const opts = {
                width: 150,
                height: 50
            }
            const infoWindow = new BMap.InfoWindow(this.address, opts)
            map.openInfoWindow(infoWindow, point)
            marker.addEventListener('click', () => {
                map.openInfoWindow(infoWindow, point)
            })

            // 标注
            // const label = new BMap.Label(this.content, {
            //     position: point,
            //     offset: new BMap.Size(-65, -70)
            // })
            // map.addOverlay(label)
            // label.setStyle({
            //     color: '#000',
            //     fontSize: '16px',
            //     fontWeight: 500,
            //     border: '1px solid #000',
            //     lineHeight: '40px',
            //     padding: '0 10px'
            // })
        }
    }
}
</script>
<style lang="scss" scoped>
#bmap {
    width: 1200px;
    height: 240px;
    margin: 0 auto;
}
</style>
